<template>
    <div class="refund-modal">
        <div class="modal-outside" @click="$emit('closeModal')" />
        <strong class="title">내역정보</strong>
        <ul>
          <li>
            <p :class="false">
              <em :class="'active'">최종 충전 잔액 : {{ Number(prepaidCardRefundInfo.refundBasedAmount).toLocaleString() }}원</em>
            </p>
          </li>
          <li>
            <p :class="false">
            <span></span>
            <em :class="'false'">충전시점 잔액 {{ Number(prepaidCardRefundInfo.lastRemainCash).toLocaleString() }}원 + 충전 {{ Number(prepaidCardRefundInfo.lastCashAmount).toLocaleString() }}원</em>
            </p>
          </li>
          <li>
            <p :class="false">
            <span></span>
            <em :class="'false'">충전 일자 : {{prepaidCardRefundInfo.lastPaymentDate}}</em>
            </p>
          </li>
          <li>
            <p :class="false">

            <em :class="'active'">환불 예정 금액 : {{ Number(prepaidCardRefundInfo.refundAmount).toLocaleString() }}원</em>
            </p>
          </li>
          <li>
            <p :class="false">
            <span></span>
            <em :class="'false'">잔액 : {{ Number(prepaidCardRefundInfo.remainCash).toLocaleString() }}원</em>
            </p>
          </li>
          <li>
            <p :class="false">
            <span></span>
            <em :class="'false'">할인 금액 비율 차감: {{ Number(prepaidCardRefundInfo.discountAmount).toLocaleString( )}}원</em>
            </p>
          </li>
          <li>
            <p :class="false">
              <span></span>
              <em :class="'false'">환불 예정금액: {{ Number(prepaidCardRefundInfo.refundAmount).toLocaleString() }}원 (잔액 - 할인 금액 차감)</em>
            </p>
          </li>
        </ul>

    </div>
</template>

<script>
export default {
    name: 'RefundInfoModal',
    props: ['prepaidCardRefundInfo'],
    data() {
        return {

        };
    },

    mounted() {
        
    },
};
</script>

<style lang="scss" scoped>
    @import '@/assets/styles/common/refundInfoModal.scss';
    @import "@/assets/styles/pages/home/emarticonBarcode.scss";
</style>